export const pollingEvents = {
  // Mediator between the polling plugin and stores that need to restart polling, breaking the circular dependency.
  restart: () => void 0,
};
